<template>
  <section class="production">
    <div class="product ">
      <div class="pro_top">
        <div v-if="productStatus" class="status">已隐藏</div>
        <div class="saas" >
          <p class="big">{{productName}}</p>
          <p class="small">{{productDes}}</p>
          <!-- <s-title-header mainTitle='SAAS管理后台' subTitle="" description="云摄影权限管理后台" marginbottom='20' ></s-title-header> -->
        </div>
        <div class="pic"><img src="../assets/docu.jpg" alt=""></div>
      </div>
      <div class="pro_bottom">
        <span><s-button @click.native="skipDm" width=0.35 height=0.14 lineHeight=0.14 color="#fff" ave="#276BEE" textWord="帮助手册" ></s-button></span>
        <span><s-button @click.native="skipUc" width='0.35' height="0.14" lineHeight=0.14 color="#276BEE" ave="#fff" textWord="更新记录" ></s-button></span>
        <span v-if="$store.getters.roler==='admin'" class="set point" @click="appearPop">设置</span>
      </div>
    </div>
  </section>
</template>
<script>
import STitleHeader from '@/components/STitleHeader'
import SButton from '@/components/SButton'
export default {
  /******************************************
  ** 组件名称
  * @description 组件描述
  * @author stone
  *****************************************
  prop1          <type>            <属性描述>
  *****************************************/
  name: 'Production',
  components: {SButton, STitleHeader},
  props: {
    productName: {
      type: String,
      default: ''
    },
    productDes: {
      type: String,
      default: ''
    },
    productId: {
      type: String,
      default: ''
    },
    productStatus: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      hided: false
    }
  },
  mounted () {
    // console.log(this.productName)
    // console.log(this.productDes)
    // console.log(this.productId)
  },
  computed: {},
  methods: {
    skipDm () {
      this.$router.push({
        name: 'DocManage',
        params: {
          id: this.productId
        }})
    },
    skipUc () {
      this.$router.push({
        name: 'UpdateCatalogue',
        params: {
          id: this.productId
        }
      })
    },
    // 点击设置
    appearPop () {
      // console.log('son')
      this.$emit('appearPopup')
    }
  }
}
</script>
<style lang="less" scoped>
  .product{
    position: relative;
    // width:282px;
    // width:25%;
    // width: 1.4rem;
    width: 80%;
    // height: 125px;
    height: 0.62rem;
    padding:0.18rem 0.15rem;
    // padding:30px 29px;
    // line-height: 40px;
    border: solid 1px #DBDBDB ;
    border-radius:4px;
    // background-color: pink;

    .pro_top{
      display:flex;
      justify-content: space-between;
      margin-bottom:10px;
      .saas .big{
        margin-bottom:10px;
        text-align: left;
        // font-size:22px;
        font-size:0.11rem;

        height: 0.15rem;
        // height: 30px;
        width: 1.05rem;
        // width: 210px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .small{
        color:#929292 ;
        // font-size:12px;
        font-size:0.06rem;
        height: 0.2rem;
        // height: 50px;
        width: 1.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }
      .pic{
        width: 0.35rem;
        // width: 70px;
        height: 0.3rem;
        // height: 60px;
        // background-image: url('../assets/docu.jpg')
        // background-position:
        img{
          // width: 78px;
          // height:100px;
          width: 0.4rem;
          height:0.5rem;
        }
      }
    }
    .pro_bottom{
      text-align: left;
      // font-size:12px;
      font-size:0.06rem;
      // display:flex;
      // justify-content: space-around;
      span{
        color:#276BEE;
        display:inline-block;
        margin-right:0.05rem;
      }
      .set{
        font-size:0.06rem;
      }
    }
}
.status {
  position: absolute;
  left: 0;
  top: 9px;
  background: #276BEE;
  color: #fff;
  border-radius: 0 20px 20px 0;
  font-size: 0.06rem;
  padding: 0.005rem 0.025rem;
}
.production{
    margin-bottom:30px;
    // margin-right:0.12rem;
    // margin-right:24px;
  }
  // .production:nth-of-type(3n){
  //   margin-right: 0px;
  // }

</style>



// WEBPACK FOOTER //
// src/components/Production.vue